import { getTimezoneOffsetString } from "utils/utils";
import HttpService from "./http.service";

class CrudService {

    getTabletTelemetryLogs = async (deviceId, { from, to, limit = 25, beforeId = null }) => {
        const query = new URLSearchParams({ from, to, limit: String(limit) });
        if (beforeId) query.set('before_id', String(beforeId));
        return await HttpService.get(`devices/${encodeURIComponent(deviceId)}/tablet-telemetry-logs?${query.toString()}`);
    };

    getServiceRequestAutoCompletions = async (payload) => {
        const endpoint = "modules/service_request_auto_completions";
        return await HttpService.get(endpoint);

    }
    disconnectDevice = async (payload) => {
        const endpoint = "modules/disconnect-device";
        return await HttpService.post(endpoint, payload);

    }
    submitCalibration = async (payload) => {
        const endpoint = "modules/submit-calibration";
        return await HttpService.post(endpoint, payload);

    }
    updateNotificationStatus = async (payload) => {
        const endpoint = "devices/update-notification-status";
        return await HttpService.post(endpoint, payload);
    }

    getDeviceActiveAlerts = async (id, channel = null) => {
        const endpoint = `devices/device-alerts/${id}?channel_number=${channel}`;
        return await HttpService.get(endpoint);
    }

    getTabletTransfers = async ({ deviceId, from, to, cursor, limit = 50, signal }) => {
        const params = new URLSearchParams({
            deviceId: String(deviceId),
            from,
            to,
            limit: String(limit),
        });
        if (cursor) params.set("cursor", cursor);
        return HttpService.get(`tablet-transfers?${params.toString()}`, { signal });
    }

    getTabletTransferSummary = async ({ deviceId, from, to, signal }) => {
        const params = new URLSearchParams({
            deviceId: String(deviceId),
            from,
            to,
            groupBy: "day",
        });
        return HttpService.get(`tablet-transfers/summary?${params.toString()}`, { signal });
    }

    getTabletTransferEvents = async (publicId, signal) =>
        HttpService.get(`tablet-transfers/${encodeURIComponent(publicId)}/events`, { signal });

    getTabletTransferCorrections = async (publicId, signal) =>
        HttpService.get(`tablet-transfers/${encodeURIComponent(publicId)}/corrections`, { signal });

    getDevicesListForOnboarding = async () => {
        const endpoint = `devices/onboarding`;
        return await HttpService.get(endpoint);
    }

    reAssginDevice = async (deviceId, entityAddressItemId) => {
        const endpoint = `devices/${deviceId}/reassign`;
        return await HttpService.patch(endpoint, {
            entity_address_item_id: entityAddressItemId,
        });
    }

    setProductionPhone = async () => {
        const endpoint = "modules/production_phone";
        return await HttpService.post(endpoint);
    }

    setTestPhone = async () => {
        const endpoint = "modules/test_phone";
        return await HttpService.post(endpoint);
    }

    setPhoneOption = async (data) => {
        const endpoint = "modules/set_phone";
        return await HttpService.post(endpoint, data);
    }

    // invoices
    getMyInvoices = async (params = {}, signal) => {
        const query = new URLSearchParams();
        if (params.page) query.set('page', String(params.page));
        if (params.page_size) query.set('page_size', String(params.page_size));
        if (params.status) query.set('status', params.status);
        return HttpService.get(`customer/invoices?${query.toString()}`, { signal });
    };

    getMyInvoice = async (invoiceId, signal) => HttpService.get(`customer/invoices/${encodeURIComponent(invoiceId)}`, { signal });

    createInvoiceCheckoutSession = async (invoiceId) => HttpService.post(`customer/invoices/${encodeURIComponent(invoiceId)}/checkout-session`, {});

    downloadMyInvoicePdf = async (invoiceId) => HttpService.get(`customer/invoices/${encodeURIComponent(invoiceId)}/pdf`, { responseType: 'blob' });

    // users requests
    imageUpload = async (formData, id) => {
        const imageUpdate = `uploads/users/${id}/profile-image`;
        return await HttpService.post(imageUpdate, formData);
    };

    getUsers = async () => {
        const usersEndpoint = "users?include=Role,Organization";
        return await HttpService.get(usersEndpoint);
    };

    deleteUser = async (id) => {
        const endpoint = `users/${id}`;
        return await HttpService.delete(endpoint);
    };

    createUser = async (payload) => {
        const endpoint = "users";
        return await HttpService.post(endpoint, payload);
    };

    getUser = async (id) => {
        const endpoint = `users/${id}?include=Role`;
        return await HttpService.get(endpoint);
    };

    getUserWithPermissions = async (id) => {
        const endpoint = `users/${id}?include=Role,Role.Permission,Organization`;
        return await HttpService.get(endpoint);
    };

    updateUser = async (payload, id) => {
        const endpoint = `users/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // roles requests
    getRoles = async () => {
        const rolesEndpoint = "roles";
        return await HttpService.get(rolesEndpoint);
    };

    updateTheme = async (payload, id) => {
        const endpoint = `users/theme/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    getProviderShareOptions = async () => {
        return await HttpService.get('providers/share-options')
    }

    // module

    loadAlertRuleLookup = async (deviceId) => {
        const lookupEndpoint = `modules/loadAlertRuleLookup/${deviceId}`;
        return await HttpService.get(lookupEndpoint);
    }

    getOrganizations = async () => {
        const organizationsEndpoint = "modules/organizations";
        return await HttpService.get(organizationsEndpoint);
    };

    getAddressTypes = async () => {
        const addressTypesEndpoint = "modules/address_types";
        return await HttpService.get(addressTypesEndpoint);
    };

    getEntityTypes = async () => {
        const entityTypesEndpoint = "modules/entity_types";
        return await HttpService.get(entityTypesEndpoint);
    };

    getItemTypes = async () => {
        const itemTypesEndpoint = "modules/item_types";
        return await HttpService.get(itemTypesEndpoint);
    };

    getContactTypes = async () => {
        const contactTypesEndpoint = "modules/contact_types";
        return await HttpService.get(contactTypesEndpoint);
    };

    getContactAddressTypes = async () => {
        const contactAddressTypesEndpoint = "modules/contact_address_types";
        return await HttpService.get(contactAddressTypesEndpoint);
    };

    getItemAttributes = async () => {
        const companiesEndpoint = "modules/item-attributes";
        return await HttpService.get(companiesEndpoint);
    };

    getModuleAddresses = async (payload) => {
        const endpoint = "modules/module_addresses";
        return await HttpService.post(endpoint, payload);
    };
    getDeviceByExternal = async () => {
        const endpoint = "modules/device-external";
        return await HttpService.get(endpoint);
    };

    getDeviceTypes = async () => {
        const deviceTypesEndpoint = "modules/device_types";
        return await HttpService.get(deviceTypesEndpoint);
    };

    getEntityAddressItems = async () => {
        const entityAddressItemsEndpoint = "modules/entity_address_items";
        return await HttpService.get(entityAddressItemsEndpoint);
    };

    getEntityAddressItemsBy = async (params) => {
        const entityAddressItemsEndpoint = params ? `entity-address-items?${params}` : "entity-address-items";
        return await HttpService.get(entityAddressItemsEndpoint);
    };

    getDeviceBrands = async () => {
        const deviceBrandsEntityEndpoint = "modules/device_brands";
        return await HttpService.get(deviceBrandsEntityEndpoint);
    };

    getDeviceModels = async () => {
        const deviceModelsEntityEndpoint = "modules/device_models";
        return await HttpService.get(deviceModelsEntityEndpoint);
    };

    getDeviceTypeBrand = async () => {
        const deviceTypeBrandsEntityEndpoint = "modules/device-type-brand";
        return await HttpService.get(deviceTypeBrandsEntityEndpoint);
    };

    getDeviceBrandModel = async () => {
        const deviceBrandModelsEndpoint = "modules/device-brand-model";
        return await HttpService.get(deviceBrandModelsEndpoint);
    };

    getDeviceModelConfig = async () => {
        const deviceModelConfigEndpoint = "modules/device-models-config";
        return await HttpService.get(deviceModelConfigEndpoint);
    };

    getAPINames = async () => {
        const apiNamesEndpoint = "modules/api-name";
        return await HttpService.get(apiNamesEndpoint);
    };

    getDeviceParameters = async () => {
        const deviceParametersEndpoint = "modules/device-parameters";
        return await HttpService.get(deviceParametersEndpoint);
    };

    getIcons = async () => {
        const iconsEndpoint = "modules/icons";
        return await HttpService.get(iconsEndpoint);
    };

    getBadges = async () => {
        const iconsEndpoint = "modules/badges";
        return await HttpService.get(iconsEndpoint);
    };

    getFieldTypes = async () => {
        const fieldTypesEndpoint = "modules/fieldTypes";
        return await HttpService.get(fieldTypesEndpoint);
    };

    getEventTypes = async () => {
        const endpoint = "modules/eventTypes";
        return await HttpService.get(endpoint);
    };

    getAlertSubTypes = async () => {
        const endpoint = "modules/alert_sub_types";
        return await HttpService.get(endpoint);
    };

    getSendToTypes = async () => {
        const endpoint = "modules/sendToTypes";
        return await HttpService.get(endpoint);
    };

    getEntityContacts = async (payload) => {
        const endpoint = "modules/entityContacts";
        return await HttpService.post(endpoint, payload);
    };

    getProviderContacts = async (payload) => {
        const endpoint = "modules/providerContacts";
        return await HttpService.post(endpoint, payload);
    };

    getDeviceParameterTypes = async () => {
        const deviceParameterTypesEndpoint = "modules/device-parameter-types";
        return await HttpService.get(deviceParameterTypesEndpoint);
    };

    getComparisonOperators = async () => {
        const comparisonOperatorsEndpoint = "modules/comparison_operators";
        return await HttpService.get(comparisonOperatorsEndpoint);
    };

    getThresholdTypes = async () => {
        const thresholdTypesEndpoint = "modules/threshold_types";
        return await HttpService.get(thresholdTypesEndpoint);
    };

    getAlertTypes = async () => {
        const endpoint = `modules/alert_types`;
        return await HttpService.get(endpoint);
    };

    getStatusTypes = async (payload) => {
        const endpoint = "modules/status_types";
        return await HttpService.post(endpoint, { module_id: payload });
    };

    getServiceItems = async () => {
        const endpoint = `modules/service_items`;
        return await HttpService.get(endpoint);
    };

    getPriorities = async () => {
        const endpoint = `modules/priorities`;
        return await HttpService.get(endpoint);
    };

    ////////////// service reuqest ////////////////

    createServiceRequest = async (payload) => {
        const endpoint = "service-request";
        return await HttpService.post(endpoint, payload);
    };

    updateServiceRequest = async (payload, id) => {
        const endpoint = `service-request/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    updateMultiServiceRequestStatusType = async (payload) => {
        const endpoint =
            "service-request/update_multi_service_request_status_type";
        return await HttpService.post(endpoint, payload);
    };

    getServiceRequests = async (address_item_id) => {
        const endpoint = `service-request/list/${address_item_id}`;
        return await HttpService.get(endpoint);
    };

    getServiceRequest = async (id) => {
        const endpoint = `service-request/${id}`;
        return await HttpService.get(endpoint);
    };

    getActiveServiceRequest = async (id) => {
        const endpoint = `service-request/active/${id}`;
        return await HttpService.get(endpoint);
    };

    deleteServiceRequest = async (id) => {
        const endpoint = `service-request/${id}`;
        return await HttpService.delete(endpoint);
    };

    getServiceLineUtils = async () => {
        const endpoint = `service-request-lines/util`
        return await HttpService.get(endpoint);
    };
    ////////////// role //////////////

    deleteRole = async (id) => {
        const endpoint = `roles/${id}`;
        return await HttpService.delete(endpoint);
    };

    createRole = async (payload) => {
        const endpoint = "roles";
        return await HttpService.post(endpoint, payload);
    };

    updateRole = async (payload, id) => {
        const endpoint = `roles/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    getRole = async (id) => {
        const endpoint = `roles/${id}`;
        return await HttpService.get(endpoint);
    };

    // categories requests
    getCategories = async () => {
        const categoriesEndpoint = "categories";
        return await HttpService.get(categoriesEndpoint);
    };

    deleteCategory = async (id) => {
        const endpoint = `categories/${id}`;
        return await HttpService.delete(endpoint);
    };

    createCategory = async (payload) => {
        const endpoint = "categories";
        return await HttpService.post(endpoint, payload);
    };

    getCategory = async (id) => {
        const categoriesEndpoint = `categories/${id}`;
        return await HttpService.get(categoriesEndpoint);
    };

    updateCategory = async (payload, id) => {
        const categoriesEndpoint = `categories/${id}`;
        return await HttpService.patch(categoriesEndpoint, payload);
    };

    // companies requests

    getCompanies = async () => {
        const companiesEndpoint = "companies";
        return await HttpService.get(companiesEndpoint);
    };

    deleteCompany = async (id) => {
        const endpoint = `companies/${id}`;
        return await HttpService.delete(endpoint);
    };

    createCompany = async (payload) => {
        const endpoint = "companies";
        return await HttpService.post(endpoint, payload);
    };

    getCompany = async (id) => {
        const companiesEndpoint = `companies/${id}`;
        return await HttpService.get(companiesEndpoint);
    };

    updateCompany = async (payload, id) => {
        const companiesEndpoint = `companies/${id}`;
        return await HttpService.patch(companiesEndpoint, payload);
    };

    // AI Prefill for customer onboarding
    // Sends optional text and image files to the backend OpenAI intake parser.
    // Returns the raw backend response for further adaptation.
    parseOnboardingIntake = async ({ text = '', companyId = undefined, files = [] } = {}) => {
        const base = {
            intent: 'entity_create_draft',
            text,
            strict_mode: true,
            dry_run: true,
            apply: false,
            secondary_contacts_strategy: 'skip',
            client_reference: 'customer-onboarding-prefill',
        };

        // No files – simple JSON POST
        if (!files || files.length === 0) {
            return await HttpService.post('openai/parse-intake', {
                ...base,
                ...(companyId ? { target_company_id: companyId } : {}),
            });
        }

        // Multipart request with files
        const formData = new FormData();
        Object.entries(base).forEach(([k, v]) => formData.append(k, String(v)));
        if (companyId) formData.append('target_company_id', String(companyId));
        files.forEach((file) => formData.append('files', file));

        return await HttpService.post('openai/parse-intake', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    };

    parseContactPrefill = async ({ text, defaultCountry, files = [] }) => {
      const body = { schema_version: 'contact_prefill.v1', text, default_country: defaultCountry };
      if (files.length === 0) return await HttpService.post('openai/contacts-prefill', body);
      const formData = new FormData();
      Object.entries(body).forEach(([key, value]) => formData.append(key, value));
      files.forEach((file) => formData.append('files', file));
      return await HttpService.post('openai/contacts-prefill', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    };


    // Entity
    getDevicesListByEntity = async (id) => {
        const EntitiesEndpoint = `entities/devices/${id}`;
        return await HttpService.get(EntitiesEndpoint);
    };
    getAddressListByEntity = async (id) => {
        const EntitiesEndpoint = `entities/address/${id}`;
        return await HttpService.get(EntitiesEndpoint);
    };

    getEntitiesList = async () => {
        const EntitiesEndpoint = "entities/list";
        return await HttpService.get(EntitiesEndpoint);
    };

    getEntities = async () => {
        const EntitiesEndpoint = "entities";
        return await HttpService.get(EntitiesEndpoint);
    };

    deleteEntity = async (id) => {
        const endpoint = `entities/${id}`;
        return await HttpService.delete(endpoint);
    };

    createEntity = async (payload) => {
        const endpoint = "entities";
        return await HttpService.post(endpoint, payload);
    };

    getEntity = async (id) => {
        const EntitiesEndpoint = `entities/${id}`;
        return await HttpService.get(EntitiesEndpoint);
    };

    updateEntity = async (payload, id) => {
        const EntitiesEndpoint = `entities/${id}`;
        return await HttpService.patch(EntitiesEndpoint, payload);
    };

    getEntityContact = async (id) => {
        const EntitiesEndpoint = `entities/contact/${id}`;
        return await HttpService.get(EntitiesEndpoint);
    };

    updateContactAccess = async (id, payload) => {
        const EntitiesEndpoint = `entities/contact/${id}`;
        return await HttpService.put(EntitiesEndpoint, payload);
    };

    // Event logs
    getEventLogs = async (params) => {
        const queryString = new URLSearchParams(params).toString();
        const eventlogsEndpoint = `eventlogs?${queryString}`;
        return await HttpService.get(eventlogsEndpoint);
    };
    deleteEventLogs = async (ids) => {
        const eventlogsEndpoint = `eventlogs`;
        return await HttpService.delete(eventlogsEndpoint, { ids: ids });
    };

    // Rivio Webhook logs
    getRivioWebHookLogs = async (params, signal) => {
        const queryString = new URLSearchParams(params).toString();
        const eventlogsEndpoint = `modules/rivio_webhook_raw_data?${queryString}`;
        return await HttpService.get(eventlogsEndpoint, { signal });
    };

    getRecentRivioWebHookRoute = async () => {
        const eventlogsEndpoint = `modules/rivio_recent_data`;
        return await HttpService.get(eventlogsEndpoint);
    };

    delRivioWebHookLogs = async (ids) => {
        const eventlogsEndpoint = `modules/delWebhook`;
        return await HttpService.delete(eventlogsEndpoint, { ids });
    };

    // Cron logs
    getCronLogs = async (params) => {
        const queryString = new URLSearchParams(params).toString();
        const eventlogsEndpoint = `modules/cron-log?${queryString}`;
        return await HttpService.get(eventlogsEndpoint);
    };

    delCronLogs = async (ids) => {
        const eventlogsEndpoint = `modules/delCronLogs`;
        return await HttpService.delete(eventlogsEndpoint, { ids });
    };

    // device setting
    getDeviceSetting = async (id) => {
        const deviceSettingEndpoint = `device-setting/${id}`
        return await HttpService.get(deviceSettingEndpoint)
    }

    updateDeviceSetting = async (payload) => {
        const deviceSettingEndpoint = `device-setting`
        return await HttpService.put(deviceSettingEndpoint, payload)
    }

    removeDeviceSetting = async (external_id, id) => {
        const deviceSettingEndpoint = `device-setting/${external_id}/${id}`
        return await HttpService.delete(deviceSettingEndpoint)
    }
    // Queue list
    fetchQueueList = async () => {
        const deviceSettingEndpoint = `device-setting/queueList`
        return await HttpService.get(deviceSettingEndpoint)
    }

    // Device mode
    getDeviceModes = async () => {
        const deviceModesEndpoint = `devices/modes`;
        return await HttpService.get(deviceModesEndpoint)
    };

    // update device information
    updateDeviceInformation = async (payload) => {
        const updateDeviceEndpoint = `devices/update-device-information`
        return await HttpService.post(updateDeviceEndpoint, payload)
    }

    // Imei Exist
    checkImeiExist = async (payload) => {
        const checkImeiExistEndpoint = "devices/identifier-exist";
        return await HttpService.post(checkImeiExistEndpoint, payload);
    };

    getDeviceModelParameter = async (type = null, model_id = null) => {
        let deviceModelParameterEndpoint = type ? `devices/device-model-parameters?type=${type}` : "devices/device-model-parameters";
        if (model_id) {
            deviceModelParameterEndpoint += `&model_id=${model_id}`;
        }
        return await HttpService.get(deviceModelParameterEndpoint);
    };

    // Storage Section
    getStorageList = async () => {
        const storagepoint = "storage";
        return await HttpService.get(storagepoint);
    };
    createStorageList = async (formData) => {
        const storagepoint = "storage";
        return await HttpService.post(storagepoint, formData);
    };
    editStorageList = async (id, formData) => {
        const storagepoint = `storage/${id}`;
        return await HttpService.put(storagepoint, formData);
    };
    deleteStorageList = async (id) => {
        const storagepoint = `storage/${id}`;
        return await HttpService.delete(storagepoint);
    };

    checkDeviceType = async (id) => {
        const deviceEndpoint = `devices/check/${id}`;
        return await HttpService.get(deviceEndpoint);
    };

    getDeviceParameter = async (id) => {
        const deviceEndpoint = `devices/deviceParameter`;
        return await HttpService.get(deviceEndpoint);
    };

    // alert
    getAlerts = async (page, limit, search) => {
        const alertsEndpoint = `alerts?page=${page}&limit=${limit}` + (search ? `&search=${search}` : '');
        return await HttpService.get(alertsEndpoint);
    };

    getSubAlerts = async (id) => {
        const alertsEndpoint = `alerts/sub_alert/${id}`;
        return await HttpService.get(alertsEndpoint);
    };

    getDeviceAlerts = async (payload, page, limit, channel = null) => {
        const alertsEndpoint = `alerts/device?page=${page}&limit=${limit}&channel_number=${channel}`;
        return await HttpService.post(alertsEndpoint, payload);
    };

    getDeviceEvent = async (id, page, pageSize) => {
        const endpoint = `events/device/${id}?page=${page}&pageSize=${pageSize}`;
        return await HttpService.get(endpoint);
    };

    removeDeviceEvent = async (id) => {
        const endpoint = `events/${id}`;
        return await HttpService.delete(endpoint);
    };

    removeDeviceMultipleEvent = async (ids) => {
        const endpoint = `events/multiple`;
        return await HttpService.delete(endpoint, { eventIds: ids });
    };

    checkPublicShareDevice = async (id) => {
        const endpoint = `common/public-share-status/${id}`;
        return await HttpService.get(endpoint);
    };

    publicShareDevice = async (payload) => {
        const endpoint = `common/public-share-status`;
        return await HttpService.post(endpoint, payload);
    };

    getAlertRules = async (payload) => {
        const endpoint = "alertrules/list";
        return await HttpService.post(endpoint, payload);
    };

    getAlertRule = async (id) => {
        const endpoint = `alertrules/${id}`;
        return await HttpService.get(endpoint);
    };

    createAlertRule = async (payload) => {
        const endpoint = `alertrules`;
        return await HttpService.post(endpoint, payload);
    };

    editAlertRule = async (payload, id) => {
        const endpoint = `alertrules/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    deleteAlertRule = async (id) => {
        const endpoint = `alertrules/${id}`;
        return await HttpService.delete(endpoint);
    };

    deleteAlert = async (id) => {
        const endpoint = `alertrules/${id}`;
        return await HttpService.delete(endpoint);
    };

    getSendGrid = async () => {
        const endpoint = "alerts/sendgrid";
        return await HttpService.get(endpoint);
    };

    getAlert = async (id) => {
        const endpoint = `alerts/${id}`;
        return await HttpService.get(endpoint);
    };

    deleteAlert = async (id) => {
        const endpoint = `alerts/${id}`;
        return await HttpService.delete(endpoint);
    };

    // provider
    getProviders = async () => {
        const providersEndpoint = "providers";
        return await HttpService.get(providersEndpoint);
    };

    getProvider = async (id) => {
        const endpoint = `providers/${id}`;
        return await HttpService.get(endpoint);
    };

    getProviderServices = async () => {
        const providersEndpoint = "providers/services";
        return await HttpService.get(providersEndpoint);
    };

    updateProvider = async (payload, id) => {
        const endpoint = `providers/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    setProviderActive = async (payload) => {
        const endpoint = `providers/active-device`;
        return await HttpService.post(endpoint, payload);
    };

    // tag requests
    getTags = async () => {
        const tagsEndpoint = "tags";
        return await HttpService.get(tagsEndpoint);
    };

    deleteTag = async (id) => {
        const endpoint = `tags/${id}`;
        return await HttpService.delete(endpoint);
    };

    createTag = async (payload) => {
        const endpoint = "tags";
        return await HttpService.post(endpoint, payload);
    };

    getTag = async (id) => {
        const endpoint = `tags/${id}`;
        return await HttpService.get(endpoint);
    };

    updateTag = async (payload, id) => {
        const endpoint = `tags/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    getCategoryOfItem = async (id) => {
        const endpoint = `items/${id}/category`;
        return await HttpService.get(endpoint);
    };

    getTagsOfItem = async (id) => {
        const endpoint = `items/${id}/tags`;
        return await HttpService.get(endpoint);
    };

    itemImageUpload = async (formData, id) => {
        const imageUpdate = `uploads/items/${id}/image`;
        return await HttpService.post(imageUpdate, formData);
    };

    // item requests
    getItems = async () => {
        const tagsEndpoint = "items";
        return await HttpService.get(tagsEndpoint);
    };

    createItem = async (payload) => {
        const endpoint = "items";
        return await HttpService.post(endpoint, payload);
    };

    deleteItem = async (id) => {
        const endpoint = `items/${id}`;
        return await HttpService.delete(endpoint);
    };

    getItem = async (id) => {
        const endpoint = `items/${id}?include=category,tags`;
        return await HttpService.get(endpoint);
    };

    getItemAttributeTypes = async () => {
        const itemTypesEndpoint = "items/attributetypes";
        return await HttpService.get(itemTypesEndpoint);
    };

    updateItem = async (payload, id) => {
        const endpoint = `items/${id}`;
        return await HttpService.put(endpoint, payload);
    };

    ////////// device ////////////

    getInternalDevices = async () => {
        const tagsEndpoint = "devices";
        return await HttpService.get(tagsEndpoint);
    };

    checkDashboardDeviceExist = async () => {
        const tagsEndpoint = `devices/check-dashboard-devices`;
        return await HttpService.get(tagsEndpoint);
    };
    
    getInternalMapDevices = async (id) => {
        const tagsEndpoint = `devices/map?device_type=${id}`;
        return await HttpService.get(tagsEndpoint);
    };
    getSingleMapDevices = async (id) => {
        const tagsEndpoint = `devices/map/${id}`;
        return await HttpService.get(tagsEndpoint);
    };

    getSidebarDevices = async () => {
        const tagsEndpoint = "devices/sidebar";
        return await HttpService.get(tagsEndpoint);
    };

    getSingleSidebarDevices = async (id) => {
        const tagsEndpoint = `devices/sidebar/${id}`;
        return await HttpService.get(tagsEndpoint);
    };

    getSummaryDevices = async () => {
        const tagsEndpoint = "devices/summary";
        return await HttpService.get(tagsEndpoint);
    };

    getDevicesList = async () => {
        const tagsEndpoint = "devices/table";
        return await HttpService.get(tagsEndpoint);
    };

    fetchDevicesList = async (params) => {
        const queryString = new URLSearchParams(params).toString();
        const tagsEndpoint = `devices/table?${queryString}`;
        return await HttpService.post(tagsEndpoint);
    };

    createDevice = async (payload) => {
        const endpoint = "devices";
        return await HttpService.post(endpoint, payload);
    };

    deleteDevice = async (id) => {
        const endpoint = `devices/${id}`;
        return await HttpService.delete(endpoint);
    };

    getDevice = async (id) => {
        const endpoint = `devices/${id}`;
        return await HttpService.get(endpoint);
    };

    getDeviceView = async (id) => {
        const endpoint = `devices/view/${id}`;
        return await HttpService.get(endpoint);
    };
    getDeviceAssetTrackerView = async (id, include) => {
        const endpoint = include ? `devices/view/asset_tracker/${id}?include=socket` : `devices/view/asset_tracker/${id}`;
        return await HttpService.get(endpoint);
    };
    getDeviceMonitorLogs = async (id, page, pageSize, search) => {
        const offset = encodeURIComponent(getTimezoneOffsetString())
        const endpoint = `devices/monitor_logs/${id}?offset=${offset}&page=${page}&pageSize=${pageSize}&search=${search}`;
        return await HttpService.get(endpoint);
    }
    getPublicDeviceView = async (id) => {
        const endpoint = `devices/public/view/${id}`;
        return await HttpService.get(endpoint);
    };

    setDeviceAlertEnable = async (payload) => {
        const endpoint = `devices/set_alert_enable`;
        return await HttpService.post(endpoint, payload);
    };

    updateDevice = async (payload, id) => {
        const endpoint = `devices/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    upsertDeviceIdentifier = async (payload, id) => {
        const endpoint = `devices/${id}/upsert-identifier`;
        return await HttpService.post(endpoint, payload);
    };

    updateDeviceThreshold = async (payload, id) => {
        const endpoint = `devices/upsert-device-threshold`;
        return await HttpService.put(endpoint, payload);
    };

    updateDeviceAttributes = async (payload, id) => {
        const endpoint = `devices/upsert-device-attribute`;
        return await HttpService.put(endpoint, payload);
    };

    upsertDeviceCalibration = async (id, payload) => {
        const endpoint = `devices/update-calibration/${id}`;
        return await HttpService.put(endpoint, payload);
    };

    updateDeviceContact = async (payload, id) => {
        const endpoint = `devices/upsert-device-contacts`;
        return await HttpService.put(endpoint, payload);
    };

    ///////////// Subscription ////////////////////
    getAllSubscription = async () => {
        const endpoint = `subscription`;
        return await HttpService.get(endpoint)
    };

    getSubscriptionByDeviceId = async (id) => {
        const endpoint = `subscription/device/${id}`;
        return await HttpService.get(endpoint)
    };

    createSubscription = async (payload) => {
        const endpoint = `subscription`;
        return await HttpService.post(endpoint, payload)
    };

    updateSubscription = async (id, payload) => {
        const endpoint = `subscription/${id}`;
        return await HttpService.put(endpoint, payload)
    };

    removeSubscription = async (id) => {
        const endpoint = `subscription/${id}`;
        return await HttpService.delete(endpoint)
    };

    getSubscriptionPlanList = async () => {
        const endpoint = `subscription/plan`;
        return await HttpService.get(endpoint)
    };

    getSubscriptionPlanListById = async (id) => {
        const endpoint = `subscription/plan/${id}`;
        return await HttpService.get(endpoint)
    };

    createSubscriptionPlan = async (payload) => {
        const endpoint = `subscription/plan`;
        return await HttpService.post(endpoint, payload)
    };

    updateSubscriptionPlan = async (id, payload) => {
        const endpoint = `subscription/plan/${id}`;
        return await HttpService.put(endpoint, payload)
    };

    removeSubscriptionPlan = async (id) => {
        const endpoint = `subscription/plan/${id}`;
        return await HttpService.delete(endpoint)
    };

    ////////////// Downlink Commands ///////////
    getCommandsByModelId = async (id) => {
        const endpoint = `downlinkCommand/model/${id}`;
        return await HttpService.get(endpoint);
    };
    sendCommand = async (payload) => {
        const endpoint = `downlinkCommand/send`;
        return await HttpService.post(endpoint, payload);
    };

    ///////////// Route Map //////////////////
    getSnapRoads = async (id) => {
        const endpoint = `route/snapRoads/${id}`;
        return await HttpService.get(endpoint);
    };
    setSnapRoads = async (payload) => {
        const endpoint = `route/snapRoads`;
        return await HttpService.post(endpoint, payload);
    };
    regenerateRoutes = async (id) => {
        const endpoint = `route/generateSnapToRoads/${id}`;
        return await HttpService.post(endpoint);
    };
    callSnapRoutes = async (payload) => {
        const endpoint = `https://roads.googleapis.com/v1/snapToRoads?interpolate=true&path=${payload}&key=${process.env.REACT_APP_MAP_API_KEY}`;
        return await HttpService.get(endpoint);
    };
    getTodayRoutes = async (id, include = null) => {
        let today_date = new Date().toISOString()
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let endpoint = `route/today/${id}?today_date=${today_date}&timezone=${timezone}`;
        if (include) {
            endpoint = `${endpoint}&include=only`
        }
        return await HttpService.get(endpoint);
    };
    getRoutes = async (id, page, rowsPerPage) => {
        let endpoint = `route/${id}?page=${page}&pageSize=${rowsPerPage}`;
        return await HttpService.get(endpoint);
    };
    getTrackingPoint = async (id) => {
        let endpoint = `route/trackingPoint/${id}`;
        return await HttpService.get(endpoint);
    };
    getRoutesUtils = async () => {
        let endpoint = `route/utils`;
        return await HttpService.get(endpoint);
    };
    deleteRoutes = async (id) => {
        const endpoint = `route/${id}`;
        return await HttpService.delete(endpoint);
    };

    // ////// Route Tracking Device //////////////
    getTrackingCounter = async (id) => {
        const endpoint = `route/tracking/${id}`;
        return await HttpService.get(endpoint);
    }
    resetTrackingCounter = async (id, parameter_name) => {
        const endpoint = `route/tracking/${id}?parameter_name=${parameter_name}`;
        return await HttpService.post(endpoint);
    }

    getAllRoutes = async ({ page, rowsPerPage, search, sortField, sortOrder, filters }) => {
        const endpoint = `route/all?page=${page}&pageSize=${rowsPerPage}&search=${search}&sortField=${sortField}&sortOrder=${sortOrder}&filters=${JSON.stringify(filters)}`;
        return await HttpService.get(endpoint);
    };
    //////////// Route Templates ///////////
    getRouteTemplates = async () => {
        const endpoint = `route/template`;
        return await HttpService.get(endpoint);
    };
    getSingleRouteTemplate = async (id) => {
        const endpoint = `route/template/${id}`;
        return await HttpService.get(endpoint);
    };
    getRouteTemplateUtils = async () => {
        const endpoint = `route/template/utils`;
        return await HttpService.get(endpoint);
    };

    createRouteTemplate = async (payload) => {
        const endpoint = `route/template`;
        return await HttpService.post(endpoint, payload);
    };

    updateRouteTemplate = async (payload, id) => {
        const endpoint = `route/template/${id}`;
        return await HttpService.put(endpoint, payload);
    };

    deleteRouteTemplate = async (id) => {
        const endpoint = `route/template/${id}`;
        return await HttpService.delete(endpoint);
    };

    ///////////// Geofences ///////////////
    getAllGeofences = async () => {
        const endpoint = `geofence`;
        return await HttpService.get(endpoint);
    }
    getGeofencesList = async ({page, pageSize, search, sortField, sortOrder, filters}) => {
        const endpoint = `geofence/list?page=${page}&pageSize=${pageSize}&search=${search}&sortField=${sortField}&sortOrder=${sortOrder}&filters=${JSON.stringify(filters)}`;
        return await HttpService.get(endpoint);
    }
    getSingleGeofence = async (id) => {
        const endpoint = `geofence/${id}`;
        return await HttpService.get(endpoint);
    }
    getGeofenceTypes = async () => {
        const endpoint = `geofence/types`;
        return await HttpService.get(endpoint);
    }

    createGeofence = async (data) => {
        const endpoint = `geofence`;
        return await HttpService.post(endpoint, data);
    }
    checkGeofenceExist = async (data) => {
        const endpoint = `geofence/exist`;
        return await HttpService.post(endpoint, data);
    }

    updateGeofence = async (data, id) => {
        const endpoint = `geofence/${id}`;
        return await HttpService.put(endpoint, data);
    };

    deleteGeofence = async (id) => {
        const endpoint = `geofence/${id}`;
        return await HttpService.delete(endpoint);
    };

    //////////// external devices ///////////////

    getExternalDevices = async () => {
        const tagsEndpoint = "devices/external";
        return await HttpService.get(tagsEndpoint);
    };

    mapDevice = async (payload) => {
        const endpoint = "devices/map";
        return await HttpService.post(endpoint, payload);
    };

    /////////////////// parameter ///////////////////

    getExternalParameters = async () => {
        const paramsEndpoint = "parameters/external-parameters";
        return await HttpService.get(paramsEndpoint);
    };

    getInternalParameters = async () => {
        const paramsEndpoint = "parameters/internal-parameters";
        return await HttpService.get(paramsEndpoint);
    };

    getDeviceParameterValues = async (id) => {
        const endpoint = `parameters/parameter-logs/${id}`;
        return await HttpService.get(endpoint);
    };

    getInternalParameter = async (id) => {
        const endpoint = `parameters/${id}`;
        return await HttpService.get(endpoint);
    };

    getInternalFromExternalParameter = async (id) => {
        const endpoint = `parameters/external/${id}`;
        return await HttpService.get(endpoint);
    };

    mapParameter = async (payload) => {
        const endpoint = "parameters/map-parameter";
        return await HttpService.post(endpoint, payload);
    };

    createInternalParameter = async (payload) => {
        const endpoint = "parameters";
        return await HttpService.post(endpoint, payload);
    };

    updateInternalParameter = async (payload, id) => {
        const endpoint = `parameters/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    deleteInternalParameter = async (id) => {
        const endpoint = `parameters/${id}`;
        return await HttpService.delete(endpoint);
    };

    removeMonitorDeviceParameterValue = async (payload) => {
        const endpoint = `modules/remove_device_parameter_value`;
        return await HttpService.delete(endpoint, payload);
    };

    ////////// device monitor ////////////

    getDeviceMonitors = async () => {
        const tagsEndpoint = "monitors";
        return await HttpService.get(tagsEndpoint);
    };

    setIsCronRequired = async ({ deviceId, status }) => {
        const tagsEndpoint = `devices/is_cron_required/${deviceId}`;
        return await HttpService.post(tagsEndpoint, { status });
    };

    getInternalRestDevices = async () => {
        const tagsEndpoint = "devices/rest";
        return await HttpService.get(tagsEndpoint);
    };

    createDeviceMonitor = async (payload) => {
        const endpoint = "monitors";
        return await HttpService.post(endpoint, payload);
    };

    deleteDeviceMonitor = async (id) => {
        const endpoint = `monitors/${id}`;
        return await HttpService.delete(endpoint);
    };

    getDeviceMonitor = async (id) => {
        const endpoint = `monitors/${id}`;
        return await HttpService.get(endpoint);
    };

    updateDeviceMonitor = async (payload, id) => {
        const endpoint = `monitors/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    //////////// contacts //////////////

    getContacts = async () => {
        const tagsEndpoint = "contacts";
        return await HttpService.get(tagsEndpoint);
    };

    createContact = async (payload) => {
        const endpoint = "contacts";
        return await HttpService.post(endpoint, payload);
    };

    createBatchContact = async (payload) => {
        const endpoint = "contacts/batch";
        return await HttpService.post(endpoint, payload);
    };

    updateContact = async (payload, id) => {
        const endpoint = `contacts/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    deleteContact = async (id) => {
        const endpoint = `contacts/${id}`;
        return await HttpService.delete(endpoint);
    };

    getContact = async (id) => {
        const endpoint = `contacts/${id}`;
        return await HttpService.get(endpoint);
    };

    getAllContactsByEntity = async (id) => {
        const endpoint = `contacts/entity/${id}`;
        return await HttpService.get(endpoint);
    };

    ////////////// channel jobs /////////////////////
    getActiveJobForTruck = async (id) => {
        const endpoint = `channel-job/jobs/active/truck/${id}`;
        return await HttpService.get(endpoint);
    }
    getJobDetail = async (id) => {
        const endpoint = `channel-job/jobs/${id}`;
        return await HttpService.get(endpoint);
    }
    getJobStages = async (id) => {
        const endpoint = `channel-job/jobs/${id}/stages`;
        return await HttpService.get(endpoint);
    }
    previewJob = async (payload) => {
        const endpoint = `channel-job/jobs/preview`;
        return await HttpService.post(endpoint, payload);
    }
    downloadJobPdf = async (payload) => {
        const endpoint = `channel-job/jobs/download`;
        return await HttpService.post(endpoint, payload, {
            responseType: 'blob', // ✅ CRITICAL
          });
    }
    downloadJobExcel = async (payload) => {
        const endpoint = `channel-job/jobs/download-excel`;
        return await HttpService.post(endpoint, payload, {
            responseType: 'blob', // ✅ CRITICAL
          });
    }
    getJobGpsWindow = async (id) => {
        const endpoint = `channel-job/jobs/${id}/gps-window?include_points=true&point_limit=2000`;
        return await HttpService.get(endpoint);
    }
    getJobList = async ({ offset = 0, limit = 10, device_id }) => {
        const endpoint = `channel-job/jobs?limit=${limit}&offset=${offset}&device_id=${device_id}&sort_by=started_at&sort_order=desc`;
        return await HttpService.get(endpoint);
    }

    ////////////// onboarding dropdown ///////////////////
    onboardingDropData = async () => {
        const endpoint = `modules/onboardingDropDown`;
        return await HttpService.get(endpoint);
    }
    onboardingCustomer = async (data) => {
        const endpoint = `modules/onboardingCustomer`;
        return await HttpService.post(endpoint, data);
    }
    addAddressToEntity = async (payload) => {
        const endpoint = `entities/address`;
        return await HttpService.post(endpoint, payload);
    }
    linkContactsToEntity = async (entityId, contactIds) => {
        const endpoint = `entities/${entityId}/contacts/batch-add`;
        return await HttpService.post(endpoint, { contact_ids: contactIds });
    }
    //////////// contact device access ////////////////////
    getContactsAccessFromDevice = async (id) => {
        const endpoint = `contact-device-access/device/${id}`;
        return await HttpService.get(endpoint);
    };
    getContactDeviceAccessList = async (id) => {
        const endpoint = `contact-device-access/${id}`;
        return await HttpService.get(endpoint);
    };
    getContactsAccessFromContact = async (id, addressItemIds) => {
        const endpoint = `contact-device-access/contact/${id}`;
        return await HttpService.post(endpoint, { addressItemIds });
    };
    getUserListByAccess = async (id) => {
        const endpoint = `contact-device-access/contact/${id}`;
        return await HttpService.get(endpoint);
    };
    upsertContactDeviceAccess = async (payload) => {
        const endpoint = `contact-device-access`;
        return await HttpService.put(endpoint, payload);
    }
    upsertContactDeviceAccessIndex = async (payload) => {
        const endpoint = `contact-device-access/contact`;
        return await HttpService.put(endpoint, payload);
    }
    updateContactDeviceAccess = async (payload) => {
        const endpoint = `contact-device-access/update`;
        return await HttpService.put(endpoint, payload);
    }
    getAccessType = async () => {
        const endpoint = `contact-device-access/access`;
        return await HttpService.get(endpoint);
    }
    getAllUserListByAccess = async () => {
        const endpoint = `contact-device-access/contact`;
        return await HttpService.get(endpoint);
    }

    //////////// apis //////////////

    getAPIs = async () => {
        const apisEndpoint = "apis";
        return await HttpService.get(apisEndpoint);
    };

    createAPI = async (payload) => {
        const endpoint = "apis";
        return await HttpService.post(endpoint, payload);
    };

    updateAPI = async (payload, id) => {
        const endpoint = `apis/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    deleteAPI = async (id) => {
        const endpoint = `apis/${id}`;
        return await HttpService.delete(endpoint);
    };

    getAPI = async (id) => {
        const endpoint = `apis/${id}`;
        return await HttpService.get(endpoint);
    };

    ///////////  Campaign /////////////////

    getCampaign = async (id) => {
        const campaignEndpoint = `campaigns/${id}`;
        return await HttpService.get(campaignEndpoint);
    }
    getUniqueCampaigns = async () => {
        const campaignEndpoint = `campaigns/unique`;
        return await HttpService.get(campaignEndpoint);
    }
    getAllCampaign = async () => {
        const campaignEndpoint = `campaigns`;
        return await HttpService.get(campaignEndpoint);
    }
    createCampaign = async (payload) => {
        const campaignEndpoint = `campaigns`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    updateCampaign = async (id, payload) => {
        const campaignEndpoint = `campaigns/${id}`;
        return await HttpService.put(campaignEndpoint, payload);
    }
    removeCampaign = async (id) => {
        const campaignEndpoint = `campaigns/${id}`;
        return await HttpService.delete(campaignEndpoint);
    }

    getCampaignCompany = async (id) => {
        const campaignEndpoint = `campaigns/company/${id}`;
        return await HttpService.get(campaignEndpoint);
    }
    getCampaignCompanyWithExternal = async (id) => {
        const campaignEndpoint = `campaigns/company/external/${id}`;
        return await HttpService.get(campaignEndpoint);
    }
    getAllCampaignCompany = async (page, pageSize) => {
        const campaignEndpoint = `campaigns/company?page=${page}&pageSize=${pageSize}`;
        return await HttpService.get(campaignEndpoint);
    }
    getCampaignCompanyByContact = async (campaign) => {
        const campaignEndpoint = `campaigns/company/contact?campaign=${campaign}`;
        return await HttpService.get(campaignEndpoint);
    }
    createCampaignCompany = async (payload) => {
        const campaignEndpoint = `campaigns/company`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    updateCampaignCompany = async (id, payload) => {
        const campaignEndpoint = `campaigns/company/${id}`;
        return await HttpService.put(campaignEndpoint, payload);
    }
    removeCampaignCompany = async (id) => {
        const campaignEndpoint = `campaigns/company/${id}`;
        return await HttpService.delete(campaignEndpoint);
    }

    getCampaignEvent = async (id) => {
        const campaignEndpoint = `campaigns/event/${id}`;
        return await HttpService.get(campaignEndpoint);
    }
    getAllCampaignEvent = async () => {
        const campaignEndpoint = `campaigns/event`;
        return await HttpService.get(campaignEndpoint);
    }
    createCampaignEvent = async (payload) => {
        const campaignEndpoint = `campaigns/event`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    updateCampaignEvent = async (id, payload) => {
        const campaignEndpoint = `campaigns/event/${id}`;
        return await HttpService.put(campaignEndpoint, payload);
    }
    removeCampaignEvent = async (id) => {
        const campaignEndpoint = `campaigns/event/${id}`;
        return await HttpService.delete(campaignEndpoint);
    }

    getCampaignContact = async (id) => {
        const campaignEndpoint = `campaigns/contact/${id}`;
        return await HttpService.get(campaignEndpoint);
    }
    getAllCampaignContact = async () => {
        const campaignEndpoint = `campaigns/contact`;
        return await HttpService.get(campaignEndpoint);
    }
    createCampaignContact = async (payload) => {
        const campaignEndpoint = `campaigns/contact`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    generateCampaignContact = async (payload) => {
        const campaignEndpoint = `campaigns/event`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    updateCampaignContact = async (id, payload) => {
        const campaignEndpoint = `campaigns/contact/${id}`;
        return await HttpService.put(campaignEndpoint, payload);
    }
    removeCampaignContact = async (id) => {
        const campaignEndpoint = `campaigns/contact/${id}`;
        return await HttpService.delete(campaignEndpoint);
    }

    getCampaignAssociationCompany = async (id) => {
        const campaignEndpoint = `campaign-association/campaign-companies`;
        return await HttpService.get(campaignEndpoint);
    }
    getCampaignAssociation = async (id) => {
        const campaignEndpoint = `campaign-association/${id}`;
        return await HttpService.get(campaignEndpoint);
    }
    getAllCampaignAssociation = async () => {
        const campaignEndpoint = `campaign-association`;
        return await HttpService.get(campaignEndpoint);
    }
    createCampaignAssociation = async (payload) => {
        const campaignEndpoint = `campaign-association`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    updateCampaignAssociation = async (id, payload) => {
        const campaignEndpoint = `campaign-association/${id}`;
        return await HttpService.put(campaignEndpoint, payload);
    }
    removeCampaignAssociation = async (id) => {
        const campaignEndpoint = `campaign-association/${id}`;
        return await HttpService.delete(campaignEndpoint);
    }

    getCampaignContactTypes = async () => {
        const campaignEndpoint = `campaigns/contact_types`;
        return await HttpService.get(campaignEndpoint);
    }

    getCampaignContactBatches = async () => {
        const campaignEndpoint = `campaigns/contact_batches`;
        return await HttpService.get(campaignEndpoint);
    }

    getCampaignDashboard = async (params) => {
        const queryString = new URLSearchParams(params).toString();
        const campaignEndpoint = `campaigns/dashboard?${queryString}`;
        return await HttpService.get(campaignEndpoint);
    }
    getCampaignDashboardCount = async (params) => {
        const queryString = new URLSearchParams(params).toString();
        const campaignEndpoint = `campaigns/dashboard-count?${queryString}`;
        return await HttpService.get(campaignEndpoint);
    }

    getCampaignSingleDashboard = async (id) => {
        const campaignEndpoint = `campaigns/dashboard/${id}`;
        return await HttpService.get(campaignEndpoint);
    }

    updateCollateralLog = async (id, payload) => {
        const campaignEndpoint = `campaigns/collateralValue/${id}`;
        return await HttpService.put(campaignEndpoint, payload);
    }

    deleteCollateralLog = async (id) => {
        const endpoint = `campaigns/collateralValue/${id}`;
        return await HttpService.delete(endpoint);
    };

    //////////// Campaign Template ///////////////
    getCampaignTemplate = async (id) => {
        const campaignEndpoint = `campaigns/template/${id}`;
        return await HttpService.get(campaignEndpoint);
    }

    getAllCampaignTemplate = async () => {
        const campaignEndpoint = `campaigns/template`;
        return await HttpService.get(campaignEndpoint);
    }

    createCampaignTemplate = async (payload) => {
        const campaignEndpoint = `campaigns/template`;
        return await HttpService.post(campaignEndpoint, payload);
    }

    updateCampaignTemplate = async (id, payload) => {
        const campaignEndpoint = `campaigns/template/${id}`;
        return await HttpService.put(campaignEndpoint, payload);
    }

    removeCampaignTemplate = async (id) => {
        const campaignEndpoint = `campaigns/template/${id}`;
        return await HttpService.delete(campaignEndpoint);
    }

    //////////// Prompt Template ///////////////
    getPromptTemplate = async (id) => {
        const campaignEndpoint = `prompt/${id}`;
        return await HttpService.get(campaignEndpoint);
    }
    getAllPromptTemplate = async () => {
        const campaignEndpoint = `prompt`;
        return await HttpService.get(campaignEndpoint);
    }
    createPromptTemplate = async (payload) => {
        const campaignEndpoint = `prompt`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    updatePromptTemplate = async (id, payload) => {
        const campaignEndpoint = `prompt/${id}`;
        return await HttpService.put(campaignEndpoint, payload);
    }
    removePromptTemplate = async (id) => {
        const campaignEndpoint = `prompt/${id}`;
        return await HttpService.delete(campaignEndpoint);
    }

    // ////////////// Common API ////////////////////
    getAllPromptTag = async () => {
        const campaignEndpoint = `common/tag_selector`;
        return await HttpService.get(campaignEndpoint);
    }
    getJobTypes = async () => {
        const campaignEndpoint = `common/job_types`;
        return await HttpService.get(campaignEndpoint);
    }
    advancedFilter = async (payload, filter) => {
        const campaignEndpoint = filter ? `common/advanced-filter?type=jobqueue` : `common/advanced-filter`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    batchCampaigns = async (payload) => {
        const campaignEndpoint = `job/batch-campaigns`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    mutationBatchJobType = async (payload) => {
        const campaignEndpoint = `job/mutation-job-batch-type`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    dynamicDashboard = async (id) => {
        const campaignEndpoint = `public/images/dashboard/${id}`;
        return await HttpService.get(campaignEndpoint);
    }
    dashboardEvent = async (id) => {
        const campaignEndpoint = `common/event?uuid=${id}`;
        return await HttpService.get(campaignEndpoint);
    }

    getCurrentProfileView = async (entityId) => {
        const endpoint = `profile-views/current?entityId=${entityId}`;
        return await HttpService.get(endpoint);
    }

    putProfileViewOverride = async (payload) => {
        const endpoint = `profile-views/override`;
        return await HttpService.put(endpoint, payload);
    }

    deleteProfileViewOverride = async (entityId) => {
        const endpoint = `profile-views/override?entityId=${entityId}`;
        return await HttpService.delete(endpoint);
    }

    putProfileViewDefault = async (payload) => {
        const endpoint = `profile-views/default`;
        return await HttpService.put(endpoint, payload);
    }

    //////////// openai /////////////////
    getOpenAIPromptAssociation = async () => {
        const campaignEndpoint = `openai/association`;
        return await HttpService.get(campaignEndpoint);
    }
    getOpenAIPromptLogs = async () => {
        const campaignEndpoint = `openai/logs`;
        return await HttpService.get(campaignEndpoint);
    }
    getOpenAIPromptAllLogs = async () => {
        const campaignEndpoint = `openai/alllogs`;
        return await HttpService.get(campaignEndpoint);
    }
    generateQueue = async (payload) => {
        const campaignEndpoint = `openai/generate`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    isLogRunning = async () => {
        const campaignEndpoint = `openai/isLogRunning`;
        return await HttpService.get(campaignEndpoint);
    }
    checkValidation = async (payload) => {
        const campaignEndpoint = `openai/checkValidation`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    checkFilter = async (payload) => {
        const campaignEndpoint = `openai/filter-stage`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    fetchResponseFromOpenAI = async (payload) => {
        const campaignEndpoint = `openai/fetchResponseOpenAI`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    updateCompanies = async (payload) => {
        const campaignEndpoint = payload?.type == 'dashboard' ? `openai/updateCompanies?isDashboard=true` : `openai/updateCompanies`;
        return await HttpService.post(campaignEndpoint, payload);
    }

    //////////// job //////////////
    getBatchJobs = async () => {
        const campaignEndpoint = `/job/getBatchJobs`;
        return await HttpService.get(campaignEndpoint);
    }
    getBatches = async () => {
        const campaignEndpoint = `/job/batches`;
        return await HttpService.get(campaignEndpoint);
    }
    multipleJob = async (payload) => {
        const campaignEndpoint = `/job/multiple-run`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    runBatch = async (payload) => {
        const campaignEndpoint = `/job/run-batch`;
        return await HttpService.post(campaignEndpoint, payload);
    }
    stopJob = async (id) => {
        const campaignEndpoint = `/job/stop-batch/${id}`;
        return await HttpService.post(campaignEndpoint, {});
    }
    setConcurrencyOption = async (payload) => {
        const campaignEndpoint = `/job/set-options`;
        return await HttpService.post(campaignEndpoint, payload);
    }

    //////////// message template //////////////

    getMessages = async () => {
        const messagesEndpoint = "messages";
        return await HttpService.get(messagesEndpoint);
    };

    createMessage = async (payload) => {
        const endpoint = "messages";
        return await HttpService.post(endpoint, payload);
    };

    updateMessage = async (payload, id) => {
        const endpoint = `messages/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    deleteMessage = async (id) => {
        const endpoint = `messages/${id}`;
        return await HttpService.delete(endpoint);
    };

    getMessage = async (id) => {
        const endpoint = `messages/${id}`;
        return await HttpService.get(endpoint);
    };

    getProvidersRelatedToServiceItem = async (id) => {
        const endpoint = `modules/providers_relatedTo_serviceItem/${id}`;
        return await HttpService.get(endpoint);
    };

    getNextRole = async (payload) => {
        const endpoint = "modules/next_role";
        return await HttpService.post(endpoint, payload);
    };

    getAddressItemProviders = async (payload) => {
        const endpoint = "modules/address_item_providers";
        return await HttpService.post(endpoint, { address_item_id: payload });
    };

    updateServiceStatus = async (payload) => {
        const endpoint = "service-request/update_service_status";
        return await HttpService.post(endpoint, payload);
    };

    getServiceRequestStatusLog = async (payload) => {
        const endpoint = "modules/status_log";
        return await HttpService.post(endpoint, payload);
    };

    getNextStatusByCurrentStatus = async (payload) => {
        const endpoint = "service-request/get_nextStatus_by_currentStatus";
        return await HttpService.post(endpoint, payload);
    };

    getEmailTemplateTypes = async () => {
        const endpoint = "modules/get_email_template_types";
        return await HttpService.post(endpoint);
    };

    getSendGridWebHook = async (id) => {
        const endpoint = `modules/get_sendgrid_web_hook/${id}`;
        return await HttpService.get(endpoint);
    }

    getTwilioWebHook = async (id) => {
        const endpoint = `modules/get_twilio_web_hook/${id}`;
        return await HttpService.get(endpoint);
    }

    getTimePeriod = async () => {
        const endpoint = "modules/get_time_period";
        return await HttpService.get(endpoint);
    }

    //////////// column setting //////////////
    getSetting = async (code) => {
        const endpoint = `/column-setting/get?code=${code}`;
        return await HttpService.get(endpoint);
    };

    setSetting = async (payload) => {
        const campaignEndpoint = `/column-setting/set`;
        return await HttpService.post(campaignEndpoint, payload);
    }

    ////////////// Entity Address Item
    createEntityAddressItem = async (payload) => {
        const campaignEndpoint = `entity-address-items/all`;
        return await HttpService.post(campaignEndpoint, payload);
    }

    ///////////// Item Attributes Values
    upsertBatchItemAttributesValues = async (payload) => {
        const campaignEndpoint = `item-attribute-values/batch`;
        return await HttpService.put(campaignEndpoint, payload);
    }
}

export default new CrudService();
